module.exports = __webpack_public_path__ + "static/media/12.5be71590.mp3";